/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class HolidaySetModel {
        public isEditing: boolean;
        public selectedHolidaySet: Wars.Domain.Model.HolidaySet;
        public holidaySets: Wars.Domain.Model.HolidaySet[];
        public isNew:boolean;
        public selectedHoliday:Wars.Domain.Model.Holiday;

        constructor(private holidaySetService:warsApp.services.HolidaySetService,private modalService:any) {
            var self = this;
            holidaySetService.getHolidaySets().then(r => {
                this.holidaySets = r;
            });
        }

        public addHolidaySet() {
            this.selectedHolidaySet = this.holidaySetService.createNewHolidaySet();
            this.isNew =true;
            this.isEditing = true;

        }

        public deleteHolidaySet(holidaySet:Wars.Domain.Model.HolidaySet) {
           holidaySet.entityAspect.setDeleted(); 
           this.saveChanges();
        }

        public saveAdd() {
            this.saveChanges();
            //this.isEditing = false;
            this.isNew = false;
        }

        public cancel() {
            this.holidaySetService.rejectChanges();
            this.isEditing = false;
        }

        public selectHolidaySet(holidaySet: Wars.Domain.Model.HolidaySet) {
            this.selectedHolidaySet = holidaySet;
            this.isEditing = true;

        }

        public saveChanges() {
            this.holidaySetService.saveAllChanges();
        }

        public deleteHoliday(holiday:Wars.Domain.Model.Holiday) {
            holiday.entityAspect.setDeleted();
            this.holidaySetService.saveAllChanges();
        }

        public selectHoliday(holiday:Wars.Domain.Model.Holiday) {
            this.selectedHoliday = holiday;
            this.openHolidayModal();
        }

        private openHolidayModal() {
                        var self  = this;
            this.modalService.showModal({
                templateUrl: "./app/views/modals/_holidayModal.html",
                controller: "holidayModalController",
                inputs: {
                    holiday:self.selectedHoliday
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.holidaySetService.saveAllChanges();
                        

                    } else {
                        self.holidaySetService.rejectChanges();
                    }
                });
            });
        }

        public addHoliday() {
            this.selectedHoliday =this.holidaySetService.createHoliday();
            this.openHolidayModal();
            this.selectedHolidaySet.holidays.push(this.selectedHoliday);
        }

    }
}